import { useState } from "react"
import { FaFolder } from "react-icons/fa"
import { ResourceFile, ResourceType } from "../Interfaces"
import { ResourceCard } from "./ResourceCard"
import { VideoDialog } from "@/components/Resource/Components/VideoDialog"
import { delete_resource } from "../API"

// Lists all the resources in the list
export function ResourceList({ 
    resources, 
    type, 
    onResourceRefresh 
}: { 
    resources: ResourceFile[], 
    type: ResourceType,
    onResourceRefresh: () => void
}) {
    const [videoDialogState, setVideoDialogState] = useState<{
        isOpen: boolean;
        fileName: string;
    }>({ isOpen: false, fileName: '' })

    const openVideoDialog = (fileName: string) => {
        setVideoDialogState({ isOpen: true, fileName });
    }

    const closeVideoDialog = () => {
        setVideoDialogState({ isOpen: false, fileName: '' });
    }

    const handleDeleteResource = async (fileName: string, resourceType: ResourceType) => {
        try {
            await delete_resource(fileName, resourceType)
            onResourceRefresh() // Refresh the resource list
        } catch (error) {
            console.error('Failed to delete resource:', error)
            alert('Failed to delete resource. Please try again.')
        }
    }

    return (
        <>
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="flex flex-col gap-4 max-h-[32rem] overflow-y-auto overflow-x-visible p-6">
                    {resources.length === 0 ? (
                        <NoResourcesFound />
                    ) : (
                        resources.map((resource) => (
                            <ResourceCard
                                key={resource.name}
                                resource={resource}
                                onOpenVideo={openVideoDialog}
                                onDelete={handleDeleteResource}
                                resourceType={type}
                                onResourceRefresh={onResourceRefresh}
                            />
                        ))
                    )}
                </div>
            </div>
            
            {/* Video Dialog rendered outside of cards to avoid event conflicts */}
            <VideoDialog 
                isOpen={videoDialogState.isOpen}
                type={type}
                onClose={closeVideoDialog}
                fileName={videoDialogState.fileName}
            />
        </>
    )
}

function NoResourcesFound() {
    return (
        <div className="flex flex-col items-center justify-center h-64 text-gray-500">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <FaFolder className="w-8 h-8 text-gray-400" />
            </div>
            
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No resources found</h3>
            <p className="text-gray-500 text-center max-w-sm">
                Upload some files to get started with your resource library. 
                Supported formats include PDFs, videos, images, and documents.
            </p>
        </div>
    )
}